export const THEMES = {
  LIGHT: "light",
  DARK: "dark"
};
export const lightTheme = theme => theme.palette.mode === "light";
export const secondarySideBarWidth = 215;
export const secondarySideBarGap = 80;